/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import styles from './styles.module.scss';
import { View } from '@az/starc-ui';
import { SecondaryRating } from './SecondaryRating';
import type { SecondaryRatingType } from '../../../interface/types';

type SecondaryRatingsProps = {
  list: SecondaryRatingType[];
};

export const SecondaryRatingsList = ({ list }: SecondaryRatingsProps) => {
  return (
    <View className={styles.secondaryRatingContainer}>
      {list.map((rating) => (
        <SecondaryRating key={rating.ratingId} {...rating} />
      ))}
    </View>
  );
};
